export async function runAsyncWithErrorMessage<T>(
  fn: () => Promise<T>,
  errorMessage: string
): Promise<T> {
  try {
    return await fn();
  } catch {
    throw new Error(errorMessage);
  }
}
